import React  from 'react';
import PropTypes from 'prop-types';
import { Tab, TabList, TabPanel } from 'react-tabs';
import css from './Profile.scss';
import { SFNotification } from 'utils/types';
import AccessibleTabs from 'common/AccessibleTabs';
import classnames from 'classnames';

/*
  Creates Tabs in profile page for student or instructor based on the role. Note: onSelect and selectedTab
  are handled in the implementing components so that Tabs can link to one another.
*/
function Profile({ children, notification, onSelect, selectedTab, tabs }) {
    return (
        <AccessibleTabs className={css['container']}
              onSelect={onSelect}
              selectedIndex={selectedTab}
              selectedTabClassName={css['tab-selected']}
              selectedTabPanelClassName={css['panel']}>
            <TabList className={css['list-container']}>
                { tabs.map(tab => <Tab data-testid={tab.id} key={tab.id}>{tab.name}</Tab>) }
            </TabList>
            <div className={classnames({[css.notification]: notification.isVisible})}>
                {notification.render()}
            </div>
            { children.map((tabPanel, idx) => tabPanel && <TabPanel key={idx}>{tabPanel}</TabPanel>) }
        </AccessibleTabs>
    );
}

Profile.propTypes = {
    notification: SFNotification.isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedTab: PropTypes.number.isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string
    })),
    children: PropTypes.arrayOf(PropTypes.node).isRequired
};

export default Profile;
